import { render, staticRenderFns } from "./VisualizarNotaFiscal.vue?vue&type=template&id=1b73f2ab&scoped=true&lang=pug"
import script from "./VisualizarNotaFiscal.vue?vue&type=script&lang=js"
export * from "./VisualizarNotaFiscal.vue?vue&type=script&lang=js"
import style0 from "./VisualizarNotaFiscal.vue?vue&type=style&index=0&id=1b73f2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73f2ab",
  null
  
)

export default component.exports